export const useIsAuthenticatedEmployee = (): boolean => {
  const authenticatedEmployee = window.localStorage.getItem("authenticatedEmployee");

  return Boolean(authenticatedEmployee);
};
